// extracted by mini-css-extract-plugin
module.exports = {"isEditable":"EditableSpan_isEditable__2--ik"};